module.exports = __webpack_public_path__ + "img/skull_20.aca1b650.png";